import TableViewContainerFactory from "./table-view-container";
import TableViewTemplate from "./table-view-template";
import reactViewGenerator from "../react-view-generator";
import director from '../../director';

const TableView = reactViewGenerator({
    containerFactory: TableViewContainerFactory,
    Template: TableViewTemplate,
    manager: director,
});
export default TableView;